import actionTypes from "./actions/types";

const initialState = {
  categories: null,
  subcategories: null,
  partitions: null,

  product: null,

  user: null,
  token: null,

  cart: {
    products: [],
    subtotal: 0,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DATA:
      return Object.assign({}, state, action.data);

    case actionTypes.UPDATE_CART:
      return Object.assign({}, state, { cart: action.cart });
    
    default:
      return state
  }
}